import { useState } from "react";
import { Collapse } from "antd";

import { __ } from "../locales/translation";

import { LayoutGrid } from "./LayoutContainers";
import Pill from "./Pill";
import Stats from "./Stats";

function StatsGrid({ onClick, data, isOpen }) {
    const { fechaInicio, plazoRescate, tipo, moneda, patrimonioTotal, inversionMinima, horarioLimite } = data;

    return (
        <div className="cot-stats-grid --fondos">
            <Stats title={`${__("Fecha de inicio")}`} value={fechaInicio || "-"} />
            <Stats title={`${__("Plazo de rescate")}`} value={plazoRescate || "-"} />
            <Stats title={`${__("Tipo de fondo")}`} value={tipo || "-"} />
            <Stats title={`${__("Moneda")}`} value={moneda || "-"} />
            <Stats title={`${__("Patrimonio total")}`} currency="ARS" value={patrimonioTotal || "-"} />
            <Stats title={`${__("Inversión Mínima")}`} currency="ARS" value={inversionMinima || "-"} />
            <Stats title={`${__("Horario límite")}`} value={horarioLimite || "-"} />

            <Pill
                text={__("Ver más")}
                onClick={onClick}
                styles={{ cursor: "pointer", visibility: !isOpen ? "visible" : "hidden" }}
            />
        </div>
    );
}

export default function CollapsableContent({ data }) {
    const [activeKey, setActiveKey] = useState([]);

    const toggleCollapse = () => {
        setActiveKey(activeKey.length ? [] : ["1"]);
    };

    const {
        fechaInicio,
        plazoRescate,
        tipo,
        moneda,
        patrimonioTotal,
        inversionMinima,
        horarioLimite,
        sociedadGerente,
        calificacion,
        benchmark,
        tickerBloomberg,
        honorarioIngreso,
        honorarioRescate,
        honorarioTransferencia,
        honorarioAdministracionGerente,
        honorarioAdministracionDepositaria,
    } = data;

    const statsGridProps = {
        fechaInicio,
        plazoRescate,
        tipo,
        moneda,
        patrimonioTotal,
        inversionMinima,
        horarioLimite,
    };
    //     <div className="cot-collapsable-content">
    //         <LayoutGrid spacingTop="0" spacingBottom="0" cols={1}>
    //             <Collapse activeKey={activeKey} onChange={toggleCollapse}>
    //                 <Collapse.Panel
    //                     header={<StatsGrid data={statsGridProps} isOpen={activeKey.length} />}
    //                     key="1"
    //                     showArrow={false}
    //                 >
    //                     <div className="collapse-content">
    //                         <div className="collapse-content-item">
    //                             <span className="small-text">{__("Sociedad depositaría")}</span>
    //                             <span className="paragraph">{sociedadGerente}</span>
    //                         </div>
    //                         <div className="collapse-content-item">
    //                             <span className="small-text">{__("Calificación")}</span>
    //                             <span className="paragraph">{calificacion}</span>
    //                         </div>
    //                         <div className="collapse-content-item">
    //                             <span className="small-text">{__("Benchmark")}</span>
    //                             <span className="paragraph">{benchmark}</span>
    //                         </div>
    //                         <div className="collapse-content-item">
    //                             <span className="small-text">{__("Código Bloomberg")}</span>
    //                             <span className="paragraph">{tickerBloomberg}</span>
    //                         </div>
    //                         {honorariosSg && (
    //                             <div className="collapse-content-item">
    //                                 <span className="small-text">{__("Honorarios SG")}</span>
    //                                 <span className="paragraph">{honorariosSg}</span>
    //                             </div>
    //                         )}
    //                         {honorariosSd && (
    //                             <div className="collapse-content-item">
    //                                 <span className="small-text">{__("Honorarios SD")}</span>
    //                                 <span className="paragraph">{honorariosSd}%</span>
    //                             </div>
    //                         )}
    //                         {honorariosTotal && (
    //                             <div className="collapse-content-item">
    //                                 <span className="small-text">{__("Honorarios Total")}</span>
    //                                 <span className="paragraph">{honorariosTotal}</span>
    //                             </div>
    //                         )}
    //                     </div>

    //                     <div className="collapse-footer">
    //                         <Pill text="Ver menos" onClick={toggleCollapse} styles={{ cursor: "pointer" }} />
    //                     </div>
    //                 </Collapse.Panel>
    //             </Collapse>
    //         </LayoutGrid>
    //     </div>
    // );

    return (
        <div className="cot-collapsable-content">
            <LayoutGrid spacingTop="0" spacingBottom="0" cols={1}>
                <Collapse
                    activeKey={activeKey}
                    onChange={toggleCollapse}
                    expandIcon={() => null}
                    items={[
                        {
                            key: "1",
                            label: <StatsGrid data={statsGridProps} isOpen={activeKey.length} />,
                            children: (
                                <>
                                    <div className="collapse-content">
                                        <div className="collapse-content-item">
                                            <span className="small-text">{__("Sociedad depositaría")}</span>
                                            <span className="paragraph">{sociedadGerente}</span>
                                        </div>
                                        <div className="collapse-content-item">
                                            <span className="small-text">{__("Calificación")}</span>
                                            <span className="paragraph">{calificacion}</span>
                                        </div>
                                        <div className="collapse-content-item">
                                            <span className="small-text">{__("Benchmark")}</span>
                                            <span className="paragraph">{benchmark}</span>
                                        </div>
                                        <div className="collapse-content-item">
                                            <span className="small-text">{__("Código Bloomberg")}</span>
                                            <span className="paragraph">{tickerBloomberg}</span>
                                        </div>

                                        <div className="collapse-content-item">
                                            <span className="small-text">{__("Honorarios Ingreso")}</span>
                                            <span className="paragraph">{honorarioIngreso || "-"}</span>
                                        </div>

                                        <div className="collapse-content-item">
                                            <span className="small-text">{__("Honorarios Rescate")}</span>
                                            <span className="paragraph">{honorarioRescate || "-"}</span>
                                        </div>

                                        <div className="collapse-content-item">
                                            <span className="small-text">{__("Honorarios Transferencia")}</span>
                                            <span className="paragraph">{honorarioTransferencia || "-"}</span>
                                        </div>

                                        <div className="collapse-content-item">
                                            <span className="small-text">{__("Honorarios Adm Gerente")}</span>
                                            <span className="paragraph">{honorarioAdministracionGerente || "-"}</span>
                                        </div>

                                        <div className="collapse-content-item">
                                            <span className="small-text">{__("Honorarios Adm Depositaria")}</span>
                                            <span className="paragraph">
                                                {honorarioAdministracionDepositaria || "-"}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="collapse-footer">
                                        <Pill
                                            text="Ver menos"
                                            onClick={toggleCollapse}
                                            styles={{ cursor: "pointer" }}
                                        />
                                    </div>
                                </>
                            ),
                        },
                    ]}
                />
            </LayoutGrid>
        </div>
    );
}
